








































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { FormInputPlugin, FormGroupPlugin, FormCheckboxPlugin, FormPlugin, SpinnerPlugin, ButtonPlugin } from "bootstrap-vue";
import FacebookLoginButton from "@/components/FacebookLoginButton.vue";
import GoogleLoginButton from "@/components/GoogleLoginButton.vue";
import { EmailCredentials } from "../../models/auth.model";
import Vuelidate from "vuelidate";
import { required, sameAs, email } from "vuelidate/lib/validators";
import { namespaceAuth, AuthActionTypes } from "../../store/auth";

Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(SpinnerPlugin);
Vue.use(Vuelidate);
Vue.use(ButtonPlugin);

@Component({
  name: "LoginPage",
  components: { FacebookLoginButton, GoogleLoginButton },
  data() {
    return {
      form: {
        email: "",
        password: "",
        remember: false
      },
      isLoading: false
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      },
      remember: {}
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]!;
      return $dirty ? !$error : null;
    }
  }
})
export default class LoginPage extends Vue {
  form!: EmailCredentials;
  isLoading!: boolean;

  async onSubmit(event: Event) {
    event.preventDefault();

    if (this.$v.$invalid) {
      this.$v.$touch();
    } else {
      this.isLoading = true;
      await this.$store.dispatch(`${namespaceAuth}/${AuthActionTypes.LoginWithEmail}`, this.form);
      this.isLoading = false;
    }
  }
}
